import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ShadowUserState {
  isImpersonating: boolean;
  originalUser: any | null;
  showAll: boolean;
}

const initialState: ShadowUserState = {
  isImpersonating: false,
  originalUser: null,
  showAll: false,
};

export const shadowUserSlice = createSlice({
  name: 'shadowUser',
  initialState,
  reducers: {
    // Commencer à utiliser un compte vendeur
    startImpersonation: (state, action: PayloadAction<any>) => {
      state.isImpersonating = true;
      state.originalUser = state.originalUser || action.payload.originalUser; // Garder le parent original
    },
    // Arrêter d'utiliser le compte vendeur
    stopImpersonation: (state) => {
      state.isImpersonating = false;
      // On garde originalUser au cas où on veut switcher vers un autre vendeur
    },
    // Réinitialiser complètement (logout par exemple)
    resetShadowUser: (state) => {
      state.isImpersonating = false;
      state.originalUser = null;
    },
    toggleShowAll: (state, action: PayloadAction<boolean>) => {
      state.showAll = action.payload;
    },
  },
});

export const {
  startImpersonation,
  stopImpersonation,
  resetShadowUser,
  toggleShowAll,
} = shadowUserSlice.actions;

export default shadowUserSlice;
